import { getLocalStorageAtom } from '../storage/local-storage-atom';

export const stickyKpiAtom = getLocalStorageAtom('stickyKpis');
